import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Spinner } from '@zillow/constellation';

const CardSpinner = ({ flexProps = {}, spinnerProps = {} }) => {
  return (
    <Flex
      display="flex"
      justifyContent="center"
      paddingTop="sm"
      paddingBottom="sm"
      data-test="card-spinner__flex"
      role="status"
      aria-label="Loading"
      {...flexProps}
    >
      <Spinner size="lg" data-test="card-spinner__spinner" {...spinnerProps} />
    </Flex>
  );
};

CardSpinner.propTypes = {
  flexProps: PropTypes.object,
  spinnerProps: PropTypes.object,
};

export default CardSpinner;
